<template>
  <html :lang="locale">
    <body :class="{ dark: darkMode }">
      <UpmWidget
        v-bind="{ as, darkMode, debug, locale, ...bindings }"
        v-on="{ upmEvent }"
      >
        <template v-for="slot in slotsArr" v-slot:[`${slot}`]>
          <slot :name="slot" />
        </template>
      </UpmWidget>
    </body>
  </html>
</template>

<script setup lang="ts">
import { computed } from "vue";
import UpmWidget from "@src/components/UpmWidget.vue";
import _compact from "lodash/compact";
import { IUpmEvent } from "@src/models/UpmEvent";

// Props

const props = withDefaults(
  defineProps<{
    darkMode?: boolean;
    debug?: boolean;
    as: string;
    locale?: string;
    slots?: string;
    bind?: Record<string, any> | string;
  }>(),
  {
    darkMode: false,
    debug: false,
    as: "",
    locale: "en",
    slots: "",
    bind: {} as any,
  }
);

const emits = defineEmits<{
  (event: "upmEvent", payload: IUpmEvent): void;
}>();

const upmEvent = (payload: IUpmEvent) => {
  emits("upmEvent", payload);
};

const bindings = computed(() => {
  if (typeof props.bind === "object") return props.bind;
  try {
    return JSON.parse(props.bind || "");
  } catch {
    return {};
  }
});

const slotsArr = computed(() =>
  _compact(["default", ...props.slots?.split(",")])
);
</script>

<style>
@import "./widget.style.css";
</style>
